import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/Footer";
import "./MainLayout.css";

function MainLayout(props) {
  // Only add top padding when the navbar is position:absolute (out of document flow).
  // Pages that use NavbarDefaultClass have a relative navbar that already pushes content down.
  const isAbsoluteNav = props.className?.includes('tw-absolute');

  return (
    <div className="mainLayout" style={{ backgroundColor: 'var(--kk-bg-alt)', transition: 'background-color 0.25s ease' }}>
      <Navbar className={props.className} title={props.title} />
      <div className={isAbsoluteNav ? "tw-pt-32" : ""}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default MainLayout;
